import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { CheckCircle2, Loader2 } from "lucide-react";

export default function BillingSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const { refresh } = useAuth();

  useEffect(() => {
    let tries = 0;
    let cancelled = false;
    const poll = async () => {
      if (!sessionId) { setStatus("error"); return; }
      try {
        const { data } = await api.get(`/billing/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          await refresh();
          return;
        }
      } catch {}
      tries += 1;
      if (tries < 15 && !cancelled) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
    return () => { cancelled = true; };
  }, [sessionId, refresh]);

  return (
    <div className="grid place-items-center py-20">
      <Card className="p-10 rounded-2xl text-center max-w-md">
        {status === "paid" ? (
          <>
            <CheckCircle2 className="h-14 w-14 text-emerald-500 mx-auto mb-4" />
            <h1 className="font-display text-2xl font-bold mb-2">You're subscribed!</h1>
            <p className="text-slate-500 mb-6">Thanks for supporting Job Done Reviews.</p>
            <Link to="/dashboard"><Button className="rounded-full bg-primary hover:bg-primary/90">Go to dashboard</Button></Link>
          </>
        ) : status === "pending" ? (
          <>
            <h1 className="font-display text-2xl font-bold mb-2">Payment is processing…</h1>
            <p className="text-slate-500 mb-6">This can take a moment. Check back in a minute.</p>
            <Link to="/dashboard"><Button variant="outline" className="rounded-full">Back to dashboard</Button></Link>
          </>
        ) : status === "error" ? (
          <>
            <h1 className="font-display text-2xl font-bold mb-2">Something went wrong</h1>
            <Link to="/settings"><Button className="rounded-full bg-primary">Back to Settings</Button></Link>
          </>
        ) : (
          <div className="text-slate-500 inline-flex items-center gap-2"><Loader2 className="h-4 w-4 animate-spin" /> Confirming payment…</div>
        )}
      </Card>
    </div>
  );
}
